const TOKEN_KEY = 'seo_machine_token';

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setStoredToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken() {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * fetch avec en-tête Bearer si un token est présent.
 * Sur 401 avec token, déconnexion locale + événement auth:logout.
 */
export async function apiFetch(input, init = {}) {
  const token = getStoredToken();
  const headers = new Headers(init.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  const url = typeof input === 'string' ? input : input.url;
  const response = await fetch(input, { ...init, headers });

  if (response.status === 401 && token && !String(url).includes('/api/auth/login')) {
    clearStoredToken();
    window.dispatchEvent(new CustomEvent('auth:logout'));
  }

  return response;
}
